{
  "title": "Blindness/Deafness",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level necromancy",
  "level": 2,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "1 minute",
  "description": [
    "You can blind or deafen a foe. Choose one creature that you can see within range to make a Constitution saving throw. If it fails, the target is either blinded or deafened (your choice) for the duration. At the end of each of its turns, the target can make a Constitution saving throw. On a success, the spell ends.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can target one additional creature for each slot level above 2nd."
  ],
  "spellLists": ["bard", "cleric", "sorcerer", "wizard"]
}
